import { BotCreateType, BotType, BotUpdateType } from "types/bot-types";

import { axios } from "./baseAxios";

const BE_URI = process.env.REACT_APP_BE_URI;

export const get = async ({
  code,
  name,
}: {
  code?: string;
  name?: string;
}): Promise<BotType[]> => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${BE_URI}/bots`,
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      code,
      name,
    },
  };

  const response = await axios.request(config);
  return response?.data;
};

export const create = async (data: BotCreateType) => {
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${BE_URI}/bots`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  const response = await axios.request(config);
  return response?.data;
};

export const update = async (data: BotUpdateType) => {
  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${BE_URI}/bots/${data?.code ?? ""}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  };

  const response = await axios.request(config);
  return response?.data;
};

export const remove = async (code: string) => {
  let config = {
    method: "delete",
    maxBodyLength: Infinity,
    url: `${BE_URI}/bots/${code ?? ""}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.request(config);
  return response?.data;
};
